// Shared content component. Legal text must render exactly as written.
const PrivacyContent = () => (
  <article className="prose prose-slate dark:prose-invert max-w-none">
    <h1>Privacy Policy</h1>
    <p>Wealthy Steward Member Portal<br />Version 1.0 draft. Effective date to be set at adoption.</p>

    <h2>Who we are</h2>
    <p>Wealthy Steward is a California Unincorporated Nonprofit Association (the "Association"). This policy explains how we handle your information when you use the member portal at wealthy-steward.lovable.app and related services (the "Portal").</p>
    <p>This policy covers the Portal. Your membership itself is governed by your Member Engagement Agreement and the Constitution. If anything in this policy conflicts with those documents, those documents control.</p>

    <h2>What we collect</h2>
    <p><strong>Information you give us.</strong> When you register and use the Portal, you provide your name, email address, and a password. As you use the Portal, you may add information about your Association and its activities: entity names, addresses, officer roles, resolutions, meeting minutes, and documents you upload to the Record.</p>
    <p><strong>Questions you submit.</strong> When you use Ask a person, you choose whether your question goes to the gathering or stays private. We keep your question, your routing choice, and the answer.</p>
    <p><strong>Conversations with Stew.</strong> When you ask Stew a question, we keep the conversation so Stew can respond and so we can improve the help content.</p>
    <p><strong>Information collected automatically.</strong> We keep basic technical records: when you log in, what device and browser you use, and error reports when something in the Portal breaks. Error reports help us find and fix problems.</p>

    <h2>How we use your information</h2>
    <p>We use your information to:</p>
    <ol>
      <li>Run your Portal account and store your governance records</li>
      <li>Answer your questions, whether through Stew, the gathering, or private support</li>
      <li>Send you service messages, such as call reminders and answers to your questions</li>
      <li>Fix errors and keep the Portal working</li>
      <li>Improve our help content and teaching materials</li>
    </ol>

    <h2>What we never do</h2>
    <p>We do not sell your information. We do not rent it. We do not share it with advertisers. There are no ads in the Portal.</p>
    <p>Private questions stay private. A question you route as private is handled only by our support team. It never becomes teaching content, help articles, or material Stew learns from. Only questions routed to the gathering, after human review and editing, may inform shared content, and never with your name attached.</p>
    <p>We do not share your personal or organizational information with outside parties without your written permission, except where required by lawful court order, consistent with your Member Engagement Agreement.</p>

    <h2>Stew, our AI assistant</h2>
    <p>Stew is an AI assistant built on Claude, a service of Anthropic. When you ask Stew a question, your question is processed by Anthropic's service to generate the answer. Stew is trained on our stewardship materials, not on your private records. Do not treat Stew's answers as legal, tax, or financial advice.</p>

    <h2>Service providers</h2>
    <p>We use a small number of service providers to run the Portal. Each one handles only what its job requires:</p>
    <ol>
      <li>Supabase hosts our database, sign in system, and file storage. Your account and your records in the Record live here.</li>
      <li>Lovable hosts the Portal application.</li>
      <li>Anthropic provides the AI service behind Stew.</li>
      <li>Help Scout handles email correspondence about your questions.</li>
      <li>Ontraport sends service emails such as call reminders.</li>
      <li>DocuSeal handles electronic signatures. We run DocuSeal on our own server at sign.wealthysteward.com, so signature documents stay on infrastructure we control.</li>
    </ol>
    <p>These providers act on our instructions. They do not get to use your information for their own purposes.</p>

    <h2>How long we keep your information</h2>
    <p>We keep your information for as long as you are a member. If your membership ends, download your documents from the Record before the end of your last paid month, as your Member Engagement Agreement describes. After your access ends, we keep records only as long as needed for our own recordkeeping and legal obligations, then delete or anonymize them.</p>

    <h2>Security</h2>
    <p>We protect your information with industry standard measures: encrypted connections, encrypted storage, access controls that limit who on our team can see what, and monitoring that alerts us to problems. No system is perfectly secure, so we also encourage you to use a strong password and keep it to yourself.</p>

    <h2>Your choices and rights</h2>
    <p>You may ask us at any time to:</p>
    <ol>
      <li>Show you the personal information we hold about you</li>
      <li>Correct information that is wrong</li>
      <li>Delete your account and personal information, subject to our recordkeeping obligations</li>
      <li>Give you a copy of your documents and records</li>
    </ol>
    <p>To make any of these requests, contact us using the address below.</p>

    <h2>Children</h2>
    <p>The Portal is for adults. It is not directed at anyone under 18, and we do not knowingly collect information from anyone under 18.</p>

    <h2>Changes to this policy</h2>
    <p>If we change this policy, we will post the new version in the Portal with a new effective date. For significant changes, we will ask you to review and accept the new version the next time you sign in.</p>

    <h2>Contact</h2>
    <p>Questions about this policy or your information: [support email address]</p>
    <p>Wealthy Steward<br />[mailing address]</p>
  </article>
);

export default PrivacyContent;
